import * as React from "react";
import type { SVGProps } from "react";
const SvgIconLockClosed = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      d="M8 9.55c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1 1.1-.5 1.1-1.1-.5-1.1-1.1-1.1m0 1.06.04.04q-.01.03-.04.04-.04 0-.04-.04 0-.03.04-.04M8 .53c-1.14 0-2.23.45-3.03 1.25s-1.26 1.9-1.26 3.04V6.4q0 .11.05.22.04.1.12.18t.19.12q.1.05.21.05.12 0 .22-.05.11-.04.19-.12t.12-.18.05-.22V4.8c0-.83.33-1.63.92-2.22S7.17 1.67 8 1.67s1.63.33 2.22.92.92 1.4.92 2.23V6.4q0 .11.05.22t.12.18.19.12.21.05.22-.05.19-.12.12-.18.04-.22V4.8c0-1.13-.45-2.22-1.25-3.03S9.13.53 8 .53m-4.78 5.3c-.89 0-1.63.74-1.63 1.64v6.37c0 .9.74 1.63 1.63 1.63h9.56c.9 0 1.63-.74 1.63-1.63V7.47c0-.9-.74-1.63-1.63-1.63zm0 1.15h9.56c.28 0 .49.21.49.49v6.37c0 .28-.21.49-.5.49H3.23c-.27 0-.49-.21-.49-.5V7.48c0-.28.22-.5.5-.5"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconLockClosed;
